import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import "./ChemComposition.css";
import CompositionCircle from "../CompositionCircle/CompositionCircle";

const ChemComposition = ({ setCompositionType }) => {
    const selectedPoint = useSelector((state) => state.points.selectedPoint);
    const [visibleCount, setVisibleCount] = useState(9);

    useEffect(() => {
        setVisibleCount(9);
    }, [selectedPoint]);

    let composition, elements, visibleElements;
    if (selectedPoint) {
        composition = selectedPoint.chemicalComposition || {};
        elements = Object.entries(composition);
        visibleElements = elements.slice(0, visibleCount);
    }
    const showMore = () => {
        setVisibleCount(visibleCount === elements.length ? 9 : elements.length);
    };

    return (
        <div className="chem-composition">
            <h3>Химический состав*</h3>
            {!selectedPoint ? (
                <p className="select-prompt">Выберите точку на карте</p>
            ) : (
                <div className="composition-container">
                    <div className="composition-grid">
                        {visibleElements.map(([element, percentage], index) => (
                            <CompositionCircle
                                key={index}
                                element={element}
                                percentage={percentage}
                                hideValue
                            />
                        ))}
                        {Array.from({ length: 9 - visibleElements.length }).map(
                            (_, index) => (
                                <div
                                    key={`empty-${index}`}
                                    className="composition-circle empty"
                                ></div>
                            )
                        )}
                    </div>
                    {elements.length > 9 && (
                        <div className="decorative-circles" onClick={showMore}>
                            <div className="decorative-circle"></div>
                            <div className="decorative-circle"></div>
                            <div className="decorative-circle"></div>
                        </div>
                    )}
                    <button onClick={() => setCompositionType("mineral")}>
                        Посмотреть минеральный состав
                    </button>
                    <p className="chem-composition-note">
                        * - данные предоставляются по запросу
                    </p>
                </div>
            )}
        </div>
    );
};

export default ChemComposition;
